import Attendees from "./Attendees";

export default Attendees;
